import { Location } from '@angular/common';
import { Directive, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NavigationService } from '~/core/services/navigation/navigation.service';
import { TitleService } from '~/core/services/title/title.service';
import { OrganizerSharedPageAbstractInterface } from '~/organizer/shared/components/pages/abstract/interfaces/page.interface.abstract';

@Directive()
export abstract class OrganizerSharedPageAbstract<
  T extends OrganizerSharedPageAbstractInterface,
> implements OnInit
{
  protected readonly pageCssClass: string;
  protected layoutCssClass: string; // Build in buildPage:Object.assign
  protected pageTitleKey = '';

  protected constructor(
    protected readonly activatedRoute: ActivatedRoute,
    protected readonly location: Location,
    protected readonly titleService: TitleService
  ) {}

  public ngOnInit(): void {
    this.buildPage();

    this.titleService.setPageTitle(this.pageTitleKey);
  }

  public get builtLayoutCssClass(): string {
    let cssClass = this.pageCssClass;

    if (this.layoutCssClass) {
      cssClass += ` ${this.layoutCssClass}`;
    }

    return cssClass;
  }

  protected abstract getPagesConfig(): { [key: string]: T };

  public abstract setPageValues(pageConfig: T): void;

  private buildPage(): void {
    const currentName = NavigationService.getCurrentName(this.activatedRoute);
    const pageConfig = this.getPagesConfig()[currentName];

    if (!pageConfig) {
      this.location.back();

      return;
    }

    this.layoutCssClass = pageConfig.layoutCssClass;

    this.setPageValues(pageConfig);
  }
}
